import * as React from "react";
import { AlgoliaConfig } from "./AlgoliaConfig.js";
import { queryStringToQueryObject } from "../utils/Algolia/utils/query-string.js";
function AlgoliaConfigProvider(props) {
  const {
    isEnabled,
    clientQueryString,
    presetQueryString,
    ruleContexts,
    locale,
    facetingAfterDistinct,
    options: { indexes },
    isMultilingualEnabled,
    priceSegmentCookie,
    children,
    serverState,
    router,
    serverUrl
  } = props;
  const { filters, pageSize, indices, sortIndices, facets, indexName, apiKey, appId } = props.options;
  const presetQueryObject = React.useMemo(
    () => queryStringToQueryObject(presetQueryString, { facets }),
    [presetQueryString, facets]
  );
  const value = React.useMemo(
    () => ({
      apiKey,
      appId,
      presetQueryString,
      router,
      indexName,
      serverState,
      isEnabled,
      pageSize,
      filters,
      facets,
      facetingAfterDistinct,
      sortIndices,
      presetQueryObject,
      clientQueryString,
      ruleContexts,
      indices,
      locale,
      indexes,
      isMultilingualEnabled,
      priceSegmentCookie,
      serverUrl
    }),
    [
      apiKey,
      appId,
      serverUrl,
      presetQueryString,
      router,
      indexName,
      serverState,
      isEnabled,
      pageSize,
      filters,
      facets,
      facetingAfterDistinct,
      sortIndices,
      presetQueryObject,
      clientQueryString,
      ruleContexts,
      indices,
      locale,
      indexes,
      isMultilingualEnabled,
      priceSegmentCookie
    ]
  );
  return /* @__PURE__ */ React.createElement(AlgoliaConfig.Provider, { value }, children);
}
export {
  AlgoliaConfigProvider
};
//# sourceMappingURL=AlgoliaConfigProvider.js.map
